import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { TableModule } from "primeng/table";
import { SharedModule } from "src/app/shared/shared.module";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { BuildingSearchComponent } from "../building-search/component/building-search.component";
import { BuildingSearchService } from "../building-search/services/buildingsearchservice";
import { AuditLogModalComponent } from "./components/audit-log-modal/audit-log-modal.component";
import { BuildingTableComponent } from "./components/building-table/building-table.component";
import { ReassignAddressExistingBuildingComponent } from "./components/reassign-address-existing-building/reassign-address-existing-building.component";
import { ReassignOptionComponent } from "./components/reassign-address/reassign-option/reassign-option.component";
import { ReassignSurveyToSurveyorComponent } from "./components/reassign-survey-to-surveyor/reassign-survey-to-surveyor.component";
import { ChangeBlockModalComponent } from "./components/change-block-modal/change-block-modal.component";
import { MatIconModule } from "@angular/material/icon";
import { EmptyBuildingListComponent } from "./components/empty-building-list/empty-building-list.component";

@NgModule({
  declarations: [
    BuildingTableComponent,
    ReassignOptionComponent,
    ReassignAddressExistingBuildingComponent,
    AuditLogModalComponent,
    BuildingSearchComponent,
    ReassignSurveyToSurveyorComponent,
    ChangeBlockModalComponent,
    EmptyBuildingListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    CheckboxModule,
    SharedModule,
    Ng2SearchPipeModule,
    MatIconModule,
  ],
  exports: [BuildingTableComponent],
  providers: [BuildingSearchService],
  entryComponents: [AuditLogModalComponent],
})
export class BuildingListModule {}
